module.exports = __webpack_public_path__ + "img/overturn.f265b4f.svg";